import { useState } from 'react';

export function useCustomerForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [cpfOrCnpj, setCpfOrCnpj] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [gender, setGender] = useState("masculino");
  const [telephone, setTelephone] = useState("");
  const [cep, setCep] = useState("");
  const [address, setAddress] = useState("");
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [number, setNumber] = useState("");
  const [complement, setComplement] = useState("");
  const [ibge, setIbge] = useState("");
  const [inscEstadual, setInscEstadual] = useState("");
  const [selectedDoc, setSelectedDoc] = useState("cpf");

  const [maskCpfjCnpj, setMaskCpfjCnpj] = useState("999.999.999-99");
  const [maskTelephone, setMaskTelephone] = useState("(99) 9999-9999");

  const clearCustomer = () => {
    setName("");
    setEmail("");
    setBirthdate("");
    setGender("masculino");
    setTelephone("");
  };

  const clearAllCustomer = () => {
    clearCustomer();
    setCep("");
    setAddress("");
    setNumber("");
    setComplement("");
    setDistrict("");
    setCity("");
    setState("");
    setCpfOrCnpj("");
    setInscEstadual("");
  };

  return {
    // Form state
    name, setName,
    email, setEmail,
    cpfOrCnpj, setCpfOrCnpj,
    birthdate, setBirthdate,
    gender, setGender,
    telephone, setTelephone,
    cep, setCep,
    address, setAddress,
    district, setDistrict,
    city, setCity,
    state, setState,
    number, setNumber,
    complement, setComplement,
    ibge, setIbge,
    inscEstadual, setInscEstadual,
    selectedDoc, setSelectedDoc,
    
    // Masks
    maskCpfjCnpj, setMaskCpfjCnpj,
    maskTelephone, setMaskTelephone,
    
    // Actions
    clearCustomer,
    clearAllCustomer
  };
}
